// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"292":"business-process","600":"customer-experience"}[chunkId] + "." + {"292":"d1ddefae","600":"7d6c194a"}[chunkId] + ".js";
};